import { Stack } from '@mui/material';
import { type FlowLlmPromptStructuredOutputFieldBase } from 'flow-schema';

import { type RequireLabelOrAria } from 'common';

import { ResponseFormatFieldHeader } from './ResponseFormatFieldHeader';
import { BlockTextField, type BlockTextFieldProps } from '../../../ConfigFields/TextField';

type BlockTextFieldOverrides = Partial<
  Omit<BlockTextFieldProps, 'fieldName' | 'type' | 'label' | 'aria-label'>
> &
  RequireLabelOrAria;

interface ResponseFormatFieldProps {
  onDelete: () => void;
  fieldNamePrefix: string;
  values: FlowLlmPromptStructuredOutputFieldBase;
  fieldLabelFieldProps: BlockTextFieldOverrides;
  definitionFieldProps: BlockTextFieldOverrides;
}

export function ResponseFormatField(props: ResponseFormatFieldProps) {
  const { onDelete, fieldNamePrefix, values, fieldLabelFieldProps, definitionFieldProps } = props;

  return (
    <Stack gap={2}>
      <ResponseFormatFieldHeader headerLabel={values.fieldLabel} onDelete={onDelete} />
      <BlockTextField
        {...fieldLabelFieldProps}
        fieldName={`${fieldNamePrefix}.fieldLabel`}
        type="text"
      />
      <BlockTextField
        {...definitionFieldProps}
        fieldName={`${fieldNamePrefix}.definition`}
        type="text"
      />
    </Stack>
  );
}
